import React, { useEffect, useState } from 'react';
import { Input, Tree, Spin, Tag, Empty } from 'antd';
import Modal from '@/components/Modal/Modal';
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from '@/script/runAsync';
import Table from '@/biz/Table.jsx';

const Dialog = ({ params, value, onOk, multiple = false, ...props }) => {
    const http = useHTTP();
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        doSearch();
    }, []);

    const doSearch = async () => {
        try {
            setLoading(true);
            const data = await runAsync(
                async () => {
                    return await http.get(`/tmteams?teamStsCode=VALID`);
                }, {
                error: { content: (err) => `查询失败: ${err.message}` },
                loading: { show: false },
                success: { show: false },
            });

            setData(data);
            setFilterData(data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const handleOk = () => {
        if (multiple) {
            onOk(selectedRows);
        } else {
            if (selectedRows.length > 0) {
                onOk(selectedRows[0]);
            }
        }
    }

    const handleSearch = (keyword) => {
        setFilterData(searchKeyword(keyword));
    }

    const searchKeyword = (keyword) => {
        const iterate = (item) => {
            const { teamNo, teamName } = item;
            const isMatchNo = () => (teamNo && teamNo.toLowerCase().indexOf(keyword.toLowerCase()) > -1);
            const isMatchName = () => (teamName && teamName.toLowerCase().indexOf(keyword.toLowerCase()) > -1);
            return isMatchNo() || isMatchName() ? { ...item } : null;
        }

        return data.map(iterate).filter(v => v);
    }

    const rowSelection = {
        type: multiple ? 'checkbox' : 'radio',
        selectedRowKeys: selectedRows.map(({ pkid }) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
    }

    const columns = [
        {
            title: '团队号',
            dataIndex: 'teamNo',
            key: 'teamNo',
            width: 150,
            ellipsis: true,
        },
        {
            title: '名称',
            dataIndex: 'teamName',
            key: 'teamName',
            width: 150,
            ellipsis: true,
        },
        // {
        //     title: '状态',
        //     dataIndex: 'teamStsCode',
        //     key: 'teamStsCode',
        //     width: 80,
        //     render: (text, record, index) => {
        //         const { teamStsCode } = record;
        //         switch (teamStsCode) {
        //             case "APP":
        //                 return "申请注册";
        //             case "VALID":
        //                 return "有效";
        //             case "DIS":
        //                 return "停用";
        //             case "DISBAND":
        //                 return "解散";
        //         }
        //     }
        // },
        {
            title: '创建人',
            dataIndex: 'crtName',
            key: 'crtName',
            width: 250,
            ellipsis: true,
        },
    ];

    return (
        <Modal
            title={"选择团队号"}
            width={800}
            style={{ top: 20 }}
            bodyStyle={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '80vh', minHeight: 320, background: '#fff', padding: 12 }}
            onOk={handleOk}
            {...props}
        >
            <div style={{ marginBottom: 12, }}>
                <Input.Search
                    enterButton="查询"
                    allowClear
                    size="small"
                    onSearch={handleSearch}
                    placeholder='可输入团队号或名称进行查询' />
            </div>

            {
                loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: '1' }}><Spin /></div>
                    :
                    filterData.length > 0 ?
                        <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#fff', padding: 0, gap: 12, flexGrow: 1 }}>
                            <Table
                                size="middle"
                                loading={loading}
                                columns={columns}
                                dataSource={filterData}
                                rowKey={"pkid"}
                                rowSelection={{ ...rowSelection }}
                            />
                        </div>
                        :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: '1', background: '#fff' }}>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        </div>
            }
        </Modal>
    );
}

export default Dialog;